import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

//utils
import queries from '../../../utils/queries'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id}>{props.elemento.descrClaseServ}</option>
  )
};

const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="claseserv" id="miLista" value={permiteUpdate?argsDocum.idClase:idLista.claseserv._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

class VerScl2 extends React.Component {
  state={
    argsDocum: {codigoSubclaseServ: this.props.idLista.codigoSubclaseServ,
                descrSubclaseServ: this.props.idLista.descrSubclaseServ,
                idClase: this.props.idLista.claseserv._id,
                codigoClaseServ: this.props.idLista.claseserv.codigoClaseServ,
                descrClaseServ: this.props.idLista.claseserv.descrClaseServ,
                _id: this.props.idLista._id},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      if(ev.target.name !== "codigoSubclaseServ"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "claseserv"){
//No se permite modificar la subclase => se comentan las lineas siguientes
            // argsDocum['idClase'] = ev.target.value
            // var miLista = document.getElementById("miLista");
            // argsDocum['codigoClaseServ'] = miLista.options[miLista.selectedIndex].attributes[0].value
            // argsDocum['descrClaseServ'] = miLista.options[miLista.selectedIndex].text
        }else{
          argsDocum[ev.target.name] = ev.target.value 
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;
    // console.log(argsDocum)
    let listaCScl = []
    if(this.props.data.allClasesServ){listaCScl = this.props.data.allClasesServ}

    // console.log("entro ver")
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large hand point down yellow icon"></i>
            Subclase
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Código</label>
                    <Form.Input autoComplete="off" name="codigoSubclaseServ" id="codigoSubclaseServ" value={argsDocum.codigoSubclaseServ} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoSubclaseServ'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrSubclaseServ" id="descrSubclaseServ" value={this.props.permiteUpdate?argsDocum.descrSubclaseServ:this.props.idLista.descrSubclaseServ} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrSubclaseServ'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Clase</label>
                    <Lista list={listaCScl} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default graphql(queries.query.allClasesServ)(VerScl2)
